import { shortMoneyNumber } from "@helpers/numbers";

const mortgages_array = [1000000, 2000000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 15000000, 20000000, 25000000, 30000000, 35000000, 40000000, 45000000, 50000000, 55000000, 60000000, 65000000, 70000000, 75000000, 80000000, 85000000, 90000000, 95000000, 100000000, 125000000, 150000000, 175000000, 200000000, 250000000, 300000000, 350000000, 400000000, 450000000, 500000000];

export const getMortgageStates = () => {
    let options = [
        {value: '', label: 'مهم نیست', checked: false}
    ];

    mortgages_array.map((mortgage) => {
        const shortMoney = shortMoneyNumber(mortgage);
        options.push({value: mortgage, label: shortMoney.num + ' ' + shortMoney.unit, checked: false})
    });

    return {
        show: false,
        options: options,
        selected_range: {
            min: null,
            max: null
        }
    }
};

